import { 
  collection, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  doc, 
  getDocs, 
  query, 
  orderBy,
  onSnapshot 
} from 'firebase/firestore';
import { db } from './config';

const COLLECTION_NAME = 'inventory';

// Get all inventory items
export const getInventoryItems = async () => {
  try {
    const q = query(collection(db, COLLECTION_NAME), orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);
    const items = [];
    querySnapshot.forEach((doc) => {
      items.push({ id: doc.id, ...doc.data() });
    });
    return { success: true, data: items };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Listen to inventory changes in real-time
export const subscribeToInventory = (callback) => {
  const q = query(collection(db, COLLECTION_NAME), orderBy('createdAt', 'desc'));
  return onSnapshot(q, (snapshot) => {
    const items = [];
    snapshot.forEach((doc) => {
      items.push({ id: doc.id, ...doc.data() });
    });
    callback(items);
  });
};

// Add new inventory item
export const addInventoryItem = async (itemData) => {
  try {
    const docRef = await addDoc(collection(db, COLLECTION_NAME), {
      ...itemData,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    });
    return { success: true, id: docRef.id };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Update inventory item
export const updateInventoryItem = async (id, itemData) => {
  try {
    const itemRef = doc(db, COLLECTION_NAME, id);
    await updateDoc(itemRef, {
      ...itemData,
      updatedAt: new Date().toISOString()
    });
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Delete inventory item
export const deleteInventoryItem = async (id) => {
  try {
    await deleteDoc(doc(db, COLLECTION_NAME, id));
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Update stock quantity
export const updateStock = async (id, newStock) => {
  try {
    const itemRef = doc(db, COLLECTION_NAME, id);
    await updateDoc(itemRef, {
      stock: newStock,
      updatedAt: new Date().toISOString()
    });
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

/**
 * Update inventory from purchase invoice
 * Used by purchase invoice service to update pricing and stock
 */
export const updateInventoryFromPurchase = async (id, purchaseData) => {
  try {
    const itemRef = doc(db, COLLECTION_NAME, id);
    await updateDoc(itemRef, purchaseData);
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

/**
 * Update pricing (wholesale and retail)
 */
export const updatePricing = async (id, wholesalePrice, retailPrice) => {
  try {
    const itemRef = doc(db, COLLECTION_NAME, id);
    await updateDoc(itemRef, {
      wholesalePrice,
      retailPrice,
      updatedAt: new Date().toISOString()
    });
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

/**
 * Increment stock quantity
 */
export const incrementStock = async (id, quantity) => {
  try {
    const itemRef = doc(db, COLLECTION_NAME, id);
    const itemSnap = await getDocs(itemRef);
    
    if (itemSnap.exists()) {
      const currentStock = itemSnap.data().stock || 0;
      await updateDoc(itemRef, {
        stock: currentStock + quantity,
        updatedAt: new Date().toISOString()
      });
      return { success: true };
    }
    
    return { success: false, error: 'Item not found' };
  } catch (error) {
    return { success: false, error: error.message };
  }
};
